import { render, staticRenderFns } from "./baseinfo.vue?vue&type=template&id=2c73aaec&scoped=true"
import script from "./baseinfo.vue?vue&type=script&lang=js"
export * from "./baseinfo.vue?vue&type=script&lang=js"
import style0 from "./baseinfo.vue?vue&type=style&index=0&id=2c73aaec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c73aaec",
  null
  
)

export default component.exports